import script from "./change-the-insured.vue?vue&type=script&setup=true&lang=ts"
export * from "./change-the-insured.vue?vue&type=script&setup=true&lang=ts"

import "./change-the-insured.vue?vue&type=style&index=0&id=5070632c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5070632c"]])

export default __exports__